/* eslint-disable import/order */

import type { ShortcutsConfig, GlobalShortcutsItem } from '../../types';
import type { UseGlobalShortcutDataInputBase, InferShortcutsOutput } from './types';
import { useGlobalShortcutsDataBFF } from './useGlobalShortcutsDataBFF';
export { useGlobalShortcutsDataRelay } from './useGlobalShortcutsDataRelay';
export { useGlobalShortcutsDataBFF } from './useGlobalShortcutsDataBFF';
/* eslint-enable import/order */

// Export the BFF version of the hook for backward compatibility
export const useGlobalShortcutsData: <
	T extends ShortcutsConfig | GlobalShortcutsItem[] | undefined = undefined,
>({
	shortcutsConfig,
	cloudId,
	product,
	onUpdateGetFilteredProductLinks,
	isShortcutsStatic,
	onError,
}: UseGlobalShortcutDataInputBase & {
	shortcutsConfig: T;
}) => InferShortcutsOutput<T> = useGlobalShortcutsDataBFF;
